export const API_CONFIG = {
    BASE_URL: process.env.REACT_APP_API_BASE_URL
};

export const PAYMENT_TIME_MINUTES = 15;

export const MENU_COLOR = {
	done: '',
	pending: 'text-yellow-600 dark:text-yellow-400',
	none: 'text-red-600 dark:text-red-400',
}

export const APP_CONFIG = {
	APP_NAME: 'Sixthball',
	VERSION: '1.0.0',
	LOGO_PATH: '/logo.png'
};

export const TRADING_CONFIG = {
	PRICE_PER_TICKET: 100,
};

export const ROLE_DISPLAY = {
	sysadmin: 'ผู้ดูแลระบบ',
	owner: 'เจ้าของ',
	agent: 'ตัวแทน',
	admin: 'ผู้ดูแล',
	customer: 'ลูกค้า'
}

export const ROLE_DISPLAY_TABLE = {
	sysadmin: 'text-red-700 dark:text-red-400 bg-red-100 dark:bg-red-900/30',
	owner: 'text-purple-700 dark:text-purple-400 bg-purple-100 dark:bg-purple-900/30',
	admin: 'text-blue-700 dark:text-blue-400 bg-blue-100 dark:bg-blue-900/30',
	agent: 'text-green-700 dark:text-green-400 bg-green-100 dark:bg-green-900/30',
	customer: 'text-gray-700 dark:text-gray-400 bg-gray-100 dark:bg-gray-900/30'
}

export const ROLE_DISPLAY_NAVBAR = {
	sysadmin: 'bg-gradient-to-r from-red-400 to-red-500 text-white',
	owner: 'bg-gradient-to-r from-yellow-400 to-orange-500 text-white',
	admin: 'bg-gradient-to-r from-blue-500 to-blue-600 text-white',
	agent: 'bg-gradient-to-r from-green-500 to-green-600 text-white',
	customer: 'bg-gradient-to-r from-gray-500 to-gray-600 text-white'
}

export const CUSTOMER_TIER = {
	normal: 'normal',
	silver: 'silver',
	gold: 'gold'
}

export const CUSTOMER_TIER_DISPLAY = {
	normal: 'Normal',
	silver: 'Silver',
	gold: 'Gold'
}

export const CUSTOMER_TIER_DISPLAY_TABLE = {
	normal: 'text-gray-700 dark:text-gray-400 bg-gray-100 dark:bg-gray-900/30',
	silver: 'text-slate-700 dark:text-slate-300 bg-slate-200 dark:bg-slate-700/40',
	gold: 'text-yellow-800 dark:text-yellow-400 bg-yellow-100 dark:bg-yellow-900/30'
}

export const CUSTOMER_TIER_DISPLAY_BADGE = {
	normal: 'bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300 border border-gray-300 dark:border-gray-600',
	silver: 'bg-gradient-to-br from-slate-200 to-slate-300 dark:from-slate-600 dark:to-slate-700 text-slate-800 dark:text-slate-100 border border-slate-400 dark:border-slate-500',
	gold: 'bg-gradient-to-br from-yellow-200 to-yellow-400 dark:from-yellow-600 dark:to-yellow-700 text-yellow-900 dark:text-yellow-100 border border-yellow-500 dark:border-yellow-600'
}

export const MSG_REMARK = {
	BANK_PAY: <span className="text-sm font-normal text-red-500">* การโอนเงินจะถูกโอนให้กับบัญชีที่ระบบุไว้เท่านั้น</span>,
	PRIZE_EXCHANGE_RATE: <span className="text-sm font-normal text-red-500">* รางวัลขึ้นอยู่กับอัตราการแลกเปลี่ยนแต่ละวัน</span>,
}

export function getCurrentRole(userRole){
	return userRole || localStorage.getItem('userRole') || 'customer';
}

export const LOTTO_TYPE = {
  powerball: 'Powerball',
  megamillions: 'Mega Millions'
}

export const LOTTO_BALL_TYPE = {
  powerball: 'Powerball',
  megamillions: 'Mega Ball'
}

export const LOTTO_BALL_TYPE_NUMBER = {
  powerball: [
    {whiteball: 69, superball: 26}
  ],
  megamillions: [
    {whiteball: 70, superball: 25}
  ]
}

export const LOTTO_TYPE_INPUT = {
  powerball: 'border-red-500 bg-red-50 dark:bg-red-900/20 text-red-600 dark:text-red-400 focus:ring-2 focus:ring-red-500 focus:border-red-500',
  megamillions: 'border-yellow-500 bg-yellow-50 dark:bg-yellow-900/20 text-yellow-600 dark:text-yellow-400 focus:ring-2 focus:ring-yellow-500 focus:border-yellow-500'
}

export const LOTTO_TYPE_DISPLAY = {
  powerball: 'bg-gradient-to-br from-red-500 to-red-700 text-white shadow-lg shadow-red-500/30',
  megamillions: 'bg-gradient-to-br from-yellow-500 to-yellow-700 text-white shadow-lg shadow-yellow-500/30'
}

export const LOTTO_TYPE_DISPLAY_WHITE_BALL = {
  powerball: 'bg-gradient-to-br from-gray-200 to-gray-300 dark:from-gray-300 dark:to-gray-400 shadow-md border border-gray-300 dark:border-gray-400',
  megamillions: 'bg-gradient-to-br from-blue-100 to-blue-300 dark:from-blue-300 dark:to-blue-400 shadow-md border border-blue-300 dark:border-blue-400'
}

export const TRANSECTION_TYPE = {
  withdraw: 'ถอน',
  receive: 'โอนให้',
  transfer: 'โอน',
  deposit: 'ฝาก',
  purchase: 'สั่งซื้อ'
}

export const TRANSECTION_TYPE_ICON = {
  withdraw: (
    <svg className="w-4 h-4" fill="#eab308" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
      <path d="M502.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l370.7 0-105.4 105.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z"/>
    </svg>
  ),
  receive:
    <svg className="w-4 h-4" fill="#15803d" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
      <path d="M502.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l370.7 0-105.4 105.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z"/>
    </svg>
  ,
  transfer: (
    <svg className="w-4 h-4" fill="#b91c1c" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
      <path d="M502.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l370.7 0-105.4 105.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z"/>
    </svg>
  ),
  deposit: (
    <svg className="w-4 h-4" fill="#15803d" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
      <path d="M502.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l370.7 0-105.4 105.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z"/>
    </svg>
  ),
}

export const PAYMENT_TYPE = {
  transfer: 'โอนเงิน',
  credit: 'เครดิต',
  discount: 'ส่วนลด'
}

export const PAYMENT_STATUS = {
	awaiting_payment: 'รอชำระเงิน',
	pending: 'รอตรวจสอบ',
	approved: 'อนุมัติแล้ว',
	rejected: 'ถูกปฏิเสธ',
	canceled: 'ถูกยกเลิก',
}

export const STATUS_NAME = {
  success: 'สำเร็จ',
  pending: 'รอดำเนินการ',
  failed: 'ไม่สำเร็จ',
}

export const MONTH_NAME_SHORT = ['ม.ค.', 'ก.พ.', 'มี.ค.', 'เม.ย.', 'พ.ค.', 'มิ.ย.', 'ก.ค.', 'ส.ค.', 'ก.ย.', 'ต.ค.', 'พ.ย.', 'ธ.ค.'];

export const MONTH_OPTIONS = MONTH_NAME_SHORT.map((month, i) => (
	<option key={i} value={i}>{month}</option>
));

export const YEAR_OPTIONS = Array.from({ length: 7 }, (_, i) => new Date().getFullYear() - 5 + i).map((year) => (
    <option key={year} value={year}>{year + 0}</option>
));

export const ICON_ACTION = {
	ADD: (
		<svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
			<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
		</svg>
	),
	EDIT: (
		<svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
			<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
		</svg>
	),
	DELETE: (
		<svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
			<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
		</svg>
	),
	SEARCH: (
		<svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
			<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
		</svg>
	),
	CLOSE: (
		<svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
			<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
		</svg>
	),
	LOGOUT: (
		<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="w-5 h-5">
			<path strokeLinecap="round" strokeLinejoin="round" d="M15.75 9V5.25A2.25 2.25 0 0013.5 3h-6a2.25 2.25 0 00-2.25 2.25v13.5A2.25 2.25 0 007.5 21h6a2.25 2.25 0 002.25-2.25V15m3 0l3-3m0 0l-3-3m3 3H9" />
		</svg>
	),
	CLEAR: (
		<svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
			<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19.428 15.428l-7.071 7.071L9 19.142 2.929 13.07l7.071-7.071L12.357 8.357l7.071 7.071z" />
			<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 2l1 3h8l-1 1-8 8-1-1 8-8 1-1z" />
		</svg>
	)
};

export const generatePromptPayQRCodeURL = (promptPayId, amount) => {
	const baseURL = 'https://promptpay.io/';
	const formattedAmount = amount ? amount.toFixed(2) : '0.00';
	return `${baseURL}${promptPayId}/${formattedAmount}.png`;
}


const BANGKOK_TIME_ZONE = 'Asia/Bangkok';

const getBangkokDateParts = (date) => {
	const parts = new Intl.DateTimeFormat('en-US', {
		timeZone: BANGKOK_TIME_ZONE,
		year: 'numeric',
		month: '2-digit',
		day: '2-digit',
		hour: '2-digit',
		minute: '2-digit',
		second: '2-digit',
		hourCycle: 'h23',
	}).formatToParts(date).reduce((acc, part) => {
		if (part.type !== 'literal') {
			acc[part.type] = Number(part.value);
		}
		return acc;
	}, {});

	return {
		year: parts.year,
		month: parts.month,
		day: parts.day,
		hours: parts.hour || 0,
		minutes: parts.minute || 0,
		seconds: parts.second || 0,
	};
};

const createDateFromParts = ({ year, month, day, hours = 0, minutes = 0, seconds = 0 }) => {
	return new Date(year, month - 1, day, hours, minutes, seconds);
};

const parseDatetimeParts = (datetime) => {
	const normalizedDatetime = datetime.trim().replace('T', ' ');
	const [datePart, timePart = '00:00:00'] = normalizedDatetime.split(' ');
	const [year, month, day] = datePart.split('-').map(Number);
	const [hours = 0, minutes = 0, seconds = 0] = timePart.split(':').map(Number);

	if ([year, month, day].some(Number.isNaN)) {
		return null;
	}

	return {
		year,
		month,
		day,
		hours: Number.isNaN(hours) ? 0 : hours,
		minutes: Number.isNaN(minutes) ? 0 : minutes,
		seconds: Number.isNaN(seconds) ? 0 : seconds,
	};
};

export const parseBangkokInstant = (datetime) => {
	if (!datetime) return null;
	if (datetime instanceof Date) return datetime;

	if (typeof datetime === 'string') {
		const trimmed = datetime.trim();
		const hasTimezone = /(?:Z|[+-]\d{2}:?\d{2})$/.test(trimmed);

		if (hasTimezone) {
			return new Date(trimmed);
		}

		const normalized = trimmed.replace(' ', 'T');
		const datetimeWithTime = normalized.includes('T') ? normalized : `${normalized}T00:00:00`;
		return new Date(`${datetimeWithTime}+07:00`);
	}

	return new Date(datetime);
};

export const dateStampToDateDB = (timestamp) => {
	const date = parseDatetimeLocal(timestamp);
	if (!date || isNaN(date.getTime())) return '';
	const year = date.getFullYear();
	const month = String(date.getMonth() + 1).padStart(2, '0');
	const day = String(date.getDate()).padStart(2, '0');
	return `${year}-${month}-${day}`;
}

export const toLocalDatetimeStr = (datetime) => {
	if (!datetime) return null;
	const d = parseDatetimeLocal(datetime);
	if (!d || isNaN(d.getTime())) return null;
	const pad = n => String(n).padStart(2, '0');
	return `${d.getFullYear()}-${pad(d.getMonth()+1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
}

// Helper function to extract time from datetime (HH:MM format, Bangkok time)
export const extractTimeFromTimestamp = (datetime) => {
	if (!datetime) return '';
	const date = parseDatetimeLocal(datetime);
	if (isNaN(date.getTime())) return '';
	const hours = String(date.getHours()).padStart(2, '0');
	const minutes = String(date.getMinutes()).padStart(2, '0');
	return `${hours}:${minutes}`;
}

// Helper function to parse datetime string to a Date object whose local fields match Bangkok wall time.
export const parseDatetimeLocal = (datetime) => {
	if (!datetime) return null;

	if (datetime instanceof Date) {
		if (isNaN(datetime.getTime())) return datetime;
		return createDateFromParts(getBangkokDateParts(datetime));
	}

	if (typeof datetime === 'string') {
		const trimmed = datetime.trim();
		const hasTimezone = /(?:Z|[+-]\d{2}:?\d{2})$/.test(trimmed);

		if (hasTimezone) {
			const date = new Date(trimmed);
			if (isNaN(date.getTime())) return date;
			return createDateFromParts(getBangkokDateParts(date));
		}

		const parts = parseDatetimeParts(trimmed);
		return parts ? createDateFromParts(parts) : new Date(trimmed);
	}

	const date = new Date(datetime);
	if (isNaN(date.getTime())) return date;
	return createDateFromParts(getBangkokDateParts(date));
}

export const toBangkokTime = (date) => {
	if (!date) return null;
	return parseDatetimeLocal(date);
}
